module.exports = __webpack_public_path__ + "static/efficacy-data-new-edb91b27a9a1912319bbdbac638416c1.png";